import { render } from "./SlSeparator.vue?vue&type=template&id=6f1725a4&scoped=true"
import script from "./SlSeparator.vue?vue&type=script&lang=js"
export * from "./SlSeparator.vue?vue&type=script&lang=js"

import "./SlSeparator.vue?vue&type=style&index=0&id=6f1725a4&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1725a4"]])

export default __exports__